import React, { useState, useEffect } from 'react';
import {
    Typography, Grid, Radio, RadioGroup, FormControlLabel, TextField
} from '@mui/material';
import { withStyles, styled } from "@mui/styles";
import en from "../../../i18n/English/Home/cal.json"
import hi from "../../../i18n/Hindi/Home/cal.json";
import kn from "../../../i18n/Kannada/Home/cal.json"
import ma from "../../../i18n/Marathi/Home/cal.json";
import gu from "../../../i18n/Gujarati/Home/cal.json"
import { useLanguage } from '../../../Context/LangContext';
const styles = theme => ({
    bmaintit: {
        color: '#3E3E3E',
        fontFamily: 'cardiuma-Bold !important',
        fontSize: "calc(32px + var(--font-delta)) !important",
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: 'normal',
    },
    maincard: {
        width: '100%',
        justifyContent: 'center',
        display: 'flex',
        padding: '100px 0px 0px 0px',
    },
    subcard: {
        width: '23%',
        padding: '24px',
        borderRadius: '8px',
        background: '#ffffff',
        "@media only screen and (max-device-width: 950px)": {
            width: '100%',
            marginTop: "15px !important"
        }
    },
    subcard1: {
        width: '40%',
        padding: '24px',
        borderRadius: '8px',
        background: '#ffffff',
    },
    subcard2: {
        width: '45%',
        padding: '24px',
        borderRadius: '8px',
        background: '#ffffff',
    },
    subtit: {
        color: '#3E3E3E',
        fontFamily: 'Inter500',
        fontSize: "calc(16px + var(--font-delta)) !important",
        fontStyle: 'normal',
        fontWeight: '500',
        lineHeight: '18px',
    },
    subtit1: {
        color: '#999999',
        fontFamily: 'Inter400 !important',
        fontSize: "calc(14px + var(--font-delta)) !important",
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '20px',
    },
    bamountcard: {
        borderRadius: '4px',
        border: '1px solid #999999',
        background: '#FFFFFF',
        padding: '6px',
        display: 'flex',
        height: '32px',
        justifyContent: 'flex-start',
    },
    bamount: {
        color: '#3E3E3E',
        fontFamily: 'cardiuma-regular !important',
        fontSize: "calc(12px + var(--font-delta)) !important",
        fontStyle: 'normal',
        textAlign: 'left',
        fontWeight: '400',
    },
    bopttxt: {
        color: '#3E3E3E',
        fontFamily: 'Inter500 !important',
        fontSize: "calc(14px + var(--font-delta)) !important",
        fontStyle: 'normal',
        fontWeight: '500',
        lineHeight: '20px',
    },
    bsubtit1: {
        color: '#3E3E3E',
        fontFamily: 'Inter400 !important',
        fontSize: "calc(12px + var(--font-delta)) !important",
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '32px',
    },
    bsubtit2: {
        color: '#3E3E3E',
        fontFamily: 'Inter400 !important',
        fontSize: "calc(12px + var(--font-delta)) !important",
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '32px',
        textAlign: 'right',
    },
    nettit: {
        color: '#3E3E3E',
        fontFamily: 'Inter700 !important',
        fontSize: "calc(14px + var(--font-delta)) !important",
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: '20px',
    },
    netamt: {
        color: '#21B12F',
        fontFamily: 'Inter700 !important',
        fontSize: "calc(14px + var(--font-delta)) !important",
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: '20px',
    },
    netamt1: {
        color: '#F74542',
        fontFamily: 'Inter700 !important',
        fontSize: "calc(14px + var(--font-delta)) !important",
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: '20px',
    },
    card: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-around',
        marginBottom: '50px',
        "@media only screen and (max-device-width: 950px)": {
            width: '100%',
            display: 'block',
            justifyContent: 'center',

        }
    }
});

const CssTextField = styled(TextField)({
    borderRadius: '8px',
    '& label.Mui-focused': {
        color: '#999999',
    },
    '& .MuiInput-underline:after': {
        borderBottomColor: '#999999',
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: '#999999',
        },
        '&:hover fieldset': {
            borderColor: '#999999',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#999999',
        },
    },
});

const Currency = ({ classes }) => {

      const { language } = useLanguage();
      const translations = { en, hi, kn, gu, ma };
      const t = translations[language];
    const [state, setState] = useState({
    b1: 49.2525,
    s1: 49.2725,
    q1: 1,
    brokerage_buy1: 0,
    turnover1: 0,
    exc_trans_charge1: 0,
    stt_total1: 0,
    sebi_charges1: 0,
    gst1: 0,
    opt1: "nse1",
    opt2: "nse2",
    brokerage_buy2: 0,
    st2: 60.75,
    b2: 0.0625,
    s2: 0.0675,
    q2: 1,
    nse2: true,
    bse2: false,
    b3: 1000,
    s3: 1100,
    q3: 400,
    nse3: true,
    bse3: false,
    brokerage_buy3: 0,
    b4: 100,
    s4: 110,
    q4: 400,
    nse4: true,
    bse4: false,
    brokerage_buy4: 0,
    // Adding missing state values
    pips1: 0,
    stamp_charges1: 0,
    total_tax1: 0,
    breakeven1: 0,
    net_profit1: 0,
    turnover2: 0,
    gst2: 0,
    exc_trans_charge2: 0,
    stamp_charges2: 0,
    total_tax2: 0,
    dp: 0,
    sebi_charges2: 0,
    breakeven2: 0,
    pips2: 0,
    net_profit2: 0
});

    useEffect(() => {
        initialRender()
    }, [state.b1, state.b2,  state.s1, state.s2, state.q1, state.q2,  state.opt1, state.opt2]);

    const handleNumericInput = (value) => {
        if (value === '') return '';
        if (value === '.') return '0.'; // Handle leading decimal
        if (/^[0-9]*\.?[0-9]*$/.test(value)) {
            // Remove leading zeros except for "0."
            if (value.startsWith('0') && value.length > 1 && !value.startsWith('0.')) {
                value = value.replace(/^0+/, '');
                if (value === '') value = '0';
            }
            return value;
        }
        return false; // Invalid input
      };



    const handle1 = (e) => {
        const selectedValue = e.target.value; // "nse4" or "bse4"

        // Update the state with the selected value
        setState((prevState) => ({
            ...prevState,
            opt1: selectedValue, // Update the `opt1` field
        }));
    };

    const handle2 = (e) => {
        const selectedValue = e.target.value; // "nse4" or "bse4"

        // Update the state with the selected value
        setState((prevState) => ({
            ...prevState,
            opt2: selectedValue, // Update the `opt1` field
        }));
    };
    const eb1 = (e) => {
        const inputValue = e.target.value;
        const processedValue = handleNumericInput(inputValue);
        if (processedValue !== false) {
            setState(prev => ({
                ...prev,
                b1: processedValue
            }));
        }
    };


    const es1 = (e) => {
        const inputValue = e.target.value;
        const processedValue = handleNumericInput(inputValue);
        if (processedValue !== false) {
            setState(prev => ({
                ...prev,
                s1: processedValue
            }));
        }
    };

    const eq1 = (e) => {
        const inputValue = e.target.value;
        const processedValue = handleNumericInput(inputValue);
        if (processedValue !== false) {
            setState(prev => ({
                ...prev,
                q1: processedValue
            }));
        }
    };

    const est2 = (e) => {
        const inputValue = e.target.value;
        const processedValue = handleNumericInput(inputValue);
        if (processedValue !== false) {
            setState(prev => ({
                ...prev,
                st2: processedValue
            }));
        }
    };


    const eb2 = (e) => {
        const inputValue = e.target.value;
        const processedValue = handleNumericInput(inputValue);
        if (processedValue !== false) {
            setState(prev => ({
                ...prev,
                b2: processedValue
            }));
        }
    };

    const es2 = (e) => {
        const inputValue = e.target.value;
        const processedValue = handleNumericInput(inputValue);
        if (processedValue !== false) {
            setState(prev => ({
                ...prev,
            s2: processedValue
            }));
        }
    };

    const eq2 = (e) => {
        const inputValue = e.target.value;
        const processedValue = handleNumericInput(inputValue);
        if (processedValue !== false) {
            setState(prev => ({
                ...prev,
                q2: processedValue
            }));
        }

    };




    const initialRender=()=>{
        let { opt1 } = state;
        let b1 = parseFloat(state.b1);
        let s1 = parseFloat(state.s1);
        let q1 = parseFloat(state.q1);

        console.log("hellow",b1,typeof(b1))

        let turnover1 = b1 + s1;
        var brokerage_buy1 = ((b1 * q1 * 1000 * 0.0003) > 20) ? 20 : parseFloat(parseFloat(b1 * q1 * 1000 * 0.0003).toFixed(2));
        var brokerage_sell1 = ((s1 * q1 * 1000 * 0.0003) > 20) ? 20 : parseFloat(parseFloat(s1 * q1 * 1000 * 0.0003).toFixed(2));
        var brokerage1 = parseFloat(parseFloat(brokerage_buy1 + brokerage_sell1).toFixed(2));

        turnover1 = (parseFloat(turnover1) * parseFloat(q1) * 1000).toFixed(2);
        let exc_trans_charge1 = 0;
        let nse_ipft1 = 0;

        if (opt1 === "nse1") {
            exc_trans_charge1 = parseFloat(parseFloat(0.000009 * turnover1).toFixed(2));
            nse_ipft1 = parseFloat(parseFloat(0.0000005 * turnover1).toFixed(2));
        } else {
            exc_trans_charge1 = parseFloat(parseFloat(0.0000025 * turnover1).toFixed(2));
            nse_ipft1 = 0;
        }

        let stt_total1 = Math.round(parseFloat(parseFloat((s1 * q1) * 0.00025).toFixed(2)));
        let sebi_charges1 = parseFloat(parseFloat(turnover1 * 0.000001).toFixed(2));
        let gst1 = ((parseFloat(brokerage1) + parseFloat(exc_trans_charge1) + parseFloat(sebi_charges1)) * 0.18).toFixed(2);

        exc_trans_charge1 = (parseFloat(exc_trans_charge1) + parseFloat(nse_ipft1)).toFixed(2);
        let stamp_charges1 = Math.round((parseFloat(b1) * parseFloat(q1) * 1000 * 0.000001).toFixed(2));

        let total_tax1 = (parseFloat(brokerage1) + parseFloat(exc_trans_charge1) + parseFloat(gst1) + parseFloat(sebi_charges1) + parseFloat(stamp_charges1)).toFixed(2);
        let breakeven1 = parseFloat(parseFloat(total_tax1 / (q1 * 1000)).toFixed(2));
        breakeven1 = isNaN(breakeven1) ? 0 : breakeven1;
        var pips1 = Math.ceil(parseFloat(breakeven1 / 0.0025));
        let net_profit1 = parseFloat(parseFloat(((s1 - b1) * q1 * 1000) - total_tax1).toFixed(2));



        let { opt2 } = state;
        let b2 = parseFloat(state.b2);
        let s2 = parseFloat(state.s2);
        let q2 = parseFloat(state.q2);
        let st2 = parseFloat(state.st2);

        var turnover2 = parseFloat(parseFloat((b2 + s2) * q2 * 1000).toFixed(2));
        var total_turnover2 = parseFloat(parseFloat((b2 + st2) * q2 * 1000) + parseFloat((s2 + st2) * q2 * 1000)).toFixed(2);
        var brokerage_buy2 = 0;
        var brokerage_sell2 = 0;

        if (b2 > 0) {
            brokerage_buy2 = (((b2 + st2) * q2 * 1000 * 0.0003) > 20) ? 20 : parseFloat(parseFloat((b2 + st2) * q2 * 1000 * 0.0003).toFixed(2));
        }
        if (s2 > 0) {
            brokerage_sell2 = (((s2 + st2) * q2 * 1000 * 0.0003) > 20) ? 20 : parseFloat(parseFloat((s2 + st2) * q2 * 1000 * 0.0003).toFixed(2));
        }
        var brokerage2 = parseFloat(parseFloat(brokerage_buy2 + brokerage_sell2).toFixed(2));
        var sebi_charges2 = parseFloat(parseFloat(turnover2 * 0.000001).toFixed(2));
        let exc_trans_charge2 = 0;
        let nse_ipft2 = 0;

        if (opt2 === "nse2") {
            exc_trans_charge2 = parseFloat(parseFloat(0.00035 * turnover2).toFixed(2));
            nse_ipft2 = parseFloat(parseFloat(0.00002 * turnover2).toFixed(2));
        } else {
            exc_trans_charge2 = parseFloat(parseFloat(0.00001 * turnover2).toFixed(2));
            nse_ipft2 = 0;
        }
        var gst2 = parseFloat(parseFloat(0.18 * (brokerage2 + exc_trans_charge2 + sebi_charges2)).toFixed(2));
        exc_trans_charge2 = parseFloat(parseFloat(exc_trans_charge2 + nse_ipft2).toFixed(2));
        var stamp_charges2 = Math.round(parseFloat(parseFloat(b2 * q2 * 1000 * 0.000001).toFixed(2)));
        var total_tax2 = (parseFloat(brokerage2) + parseFloat(exc_trans_charge2) + parseFloat(gst2) + parseFloat(sebi_charges2) + parseFloat(stamp_charges2)).toFixed(2);
        var breakeven2 = parseFloat(parseFloat(total_tax2 / (q2 * 1000)).toFixed(4));
        breakeven2 = isNaN(breakeven2) ? 0 : breakeven2;

        var pips2 = Math.ceil(parseFloat(breakeven2 / 0.0025));
        var net_profit2 = parseFloat(parseFloat(((s2 - b2) * q2 * 1000) - total_tax2).toFixed(2));


        setState({
            ...state,
            pips1: pips1,
            brokerage_buy1: brokerage1,
            turnover1: turnover1,
            stt_total1: stt_total1,
            sebi_charges1: sebi_charges1,
            exc_trans_charge1: exc_trans_charge1,
            gst1: gst1,
            stamp_charges1: stamp_charges1,
            total_tax1: total_tax1,
            breakeven1: breakeven1,
            net_profit1: net_profit1,


            brokerage_buy2: brokerage2,
            turnover2: turnover2,
            gst2: gst2,
            exc_trans_charge2: exc_trans_charge2,
            stamp_charges2: stamp_charges2,
            total_tax2: total_tax2,
            dp: 0,
            sebi_charges2: sebi_charges2,
            breakeven2: breakeven2,
            pips2: pips2,
            net_profit2: net_profit2
        });
    }

    return (
        <div className={classes.card}>
            <Grid className={classes.subcard1}>
                <Typography className={classes.subtit} style={{ fontWeight: 500 }}>{t.futures}</Typography>
                <Grid style={{ width: '100%', display: 'flex', justifyContent: 'space-evenly', marginTop: '8px' }}>
                    <Grid style={{ width: '30%' }}>
                        <Typography className={classes.subtit1}>
                            {t.buy}
                        </Typography>
                    </Grid>
                    <Grid style={{ width: '30%' }}>
                        <Typography className={classes.subtit1}>
                            {t.sell}
                        </Typography>
                    </Grid>
                    <Grid style={{ width: '30%' }}>
                        <Typography className={classes.subtit1}>
                            {t.quantity}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex', justifyContent: 'space-evenly', marginTop: '8px' }}>
                    <Grid style={{ width: '30%' }}>
                        <CssTextField
                            value={state.b1}
                            name="buy"
                            type="text"
                            autoComplete="off"
                            inputProps={{
                                 "aria-label": "BUY",
                                style: {
                                    height: "1px",
                                    fontSize: "calc(14px + var(--font-delta))",
                                    fontFamily: 'cardiuma-Bold !important',
                                    backgroundColor: '#FFF',
                                    paddingLeft: 4,
                                    paddingRight: 4,
                                    color: '#3E3E3E',
                                },
                            }}
                            onChange={(e) => eb1(e)}
                        />
                    </Grid>
                    <Grid style={{ width: '30%' }}>
                        <CssTextField
                            value={state.s1}
                            name="sell"
                            type="text"
                            autoComplete="off"
                            inputProps={{
                                 "aria-label": "SELL",
                                style: {
                                    height: "1px",
                                    fontSize: "calc(14px + var(--font-delta))",
                                    fontFamily: 'cardiuma-Bold !important',
                                    backgroundColor: '#FFF',
                                    paddingLeft: 4,
                                    paddingRight: 4,
                                    color: '#3E3E3E',
                                },
                            }}
                            onChange={(e) => es1(e)}
                        />
                    </Grid>
                    <Grid style={{ width: '30%' }}>
                        <CssTextField
                            value={state.q1}
                            name="quantity"
                            type="text"
                            autoComplete="off"
                            inputProps={{
                                 "aria-label": "QUANTITY",
                                style: {
                                    height: "1px",
                                    fontSize: "calc(14px + var(--font-delta))",
                                    fontFamily: 'cardiuma-Bold !important',
                                    backgroundColor: '#FFF',
                                    paddingLeft: 4,
                                    paddingRight: 4,
                                    color: '#3E3E3E',
                                },
                            }}
                            onChange={(e) => eq1(e)}
                        />
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex', marginTop: '10px', justifyContent: 'center' }}>
                    <RadioGroup
                        row
                        value={state.opt1}
                        onChange={handle1}
                    >
                        <FormControlLabel value="nse1" control={<Radio
                            disableRipple
                            size='small'
                            sx={{
                                color: "#093265",
                                "&.Mui-checked": {
                                    position: "relative",
                                    "&::before": {
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        color: "yellow"
                                    },
                                    "&::after": {
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        backgroundColor: "#093265",
                                        borderColor: "#ffffff",
                                        color: "yellow"
                                    },
                                    '& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root) path':
                                    {
                                        stroke: '#ffffff',
                                        strokeWidth: 0.5,
                                    },
                                }
                            }}
                        />} label={<Typography className={classes.bopttxt}>{t.nse}</Typography>} />
                        <FormControlLabel value="bse1" control={<Radio
                            size='small'
                            sx={{
                                color: "#093265",
                                "&.Mui-checked": {
                                    position: "relative",
                                    "&::before": {
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        color: "yellow"
                                    },
                                    "&::after": {
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        backgroundColor: "#093265",
                                        borderColor: "#ffffff",
                                        color: "yellow"
                                    },
                                    '& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root) path':
                                    {
                                        stroke: '#ffffff',
                                        strokeWidth: 0.5,
                                    },
                                }
                            }}
                        />} label={<Typography className={classes.bopttxt}>{t.bse}</Typography>} />
                    </RadioGroup>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex' }}>
                    <Grid style={{ width: '50%' }}>
                        <Typography className={classes.subtit1}>{t.turnover}</Typography>
                    </Grid>
                    <Grid style={{ width: '50%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.turnover1}</Typography>
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid style={{ width: '50%' }}>
                        <Typography className={classes.subtit1}>{t.brokerage}</Typography>
                    </Grid>
                    <Grid style={{ width: '50%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.brokerage_buy1}</Typography>
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.exchangeTxnCharge}</Typography>
                    </Grid>
                    <Grid style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.exc_trans_charge1}</Typography>
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.clearingCharge}</Typography>
                    </Grid>
                    <Grid style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>0</Typography>
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.gst}</Typography>
                    </Grid>
                    <Grid style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.gst1}</Typography>
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.sebiCharges}</Typography>
                    </Grid>
                    <Grid style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.sebi_charges1}</Typography>
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.stampDuty}</Typography>
                    </Grid>
                    <Grid style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.stamp_charges1}</Typography>
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.totalTaxCharges}</Typography>
                    </Grid>
                    <Grid style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.total_tax1}</Typography>
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.pointsBreakeven}</Typography>
                    </Grid>
                    <Grid style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.breakeven1}</Typography>
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.pipsBreakeven}</Typography>
                    </Grid>
                    <Grid style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.pips1}</Typography>
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex', marginTop: '30px' }}>
                    <Grid style={{ width: '60%' }}>
                        <Typography className={classes.nettit} sx={{ fontWeight: 700 }}>{t.netPL}</Typography>
                    </Grid>
                    <Grid style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={state.net_profit1 > 0 ? classes.netamt : classes.netamt1}>{state.net_profit1}</Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid className={classes.subcard1}>
                <Typography className={classes.subtit} style={{ fontWeight: 500 }}> {t.options}</Typography>
                <Grid style={{ width: '100%', display: 'flex', justifyContent: 'space-evenly', marginTop: '8px' }}>
                    <Grid style={{ width: '25%' }}>
                        <Typography className={classes.subtit1}>
                            {t.strikePrice}
                        </Typography>
                    </Grid>
                    <Grid style={{ width: '22%' }}>
                        <Typography className={classes.subtit1}>
                            {t.buy}
                        </Typography>
                    </Grid>
                    <Grid style={{ width: '22%' }}>
                        <Typography className={classes.subtit1}>
                            {t.sell}
                        </Typography>
                    </Grid>
                    <Grid style={{ width: '20%' }}>
                        <Typography className={classes.subtit1}>
                            {t.quantity}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex', justifyContent: 'space-evenly', marginTop: '8px' }}>
                    <Grid style={{ width: '25%' }}>
                        <CssTextField
                            value={state.st2}
                            name="Strike"
                            type="text"
                            autoComplete="off"
                            inputProps={{
                                "aria-label": "Strike Price",
                                style: {
                                    height: "1px",
                                    fontSize: "calc(14px + var(--font-delta))",
                                    fontFamily: 'cardiuma-Bold !important',
                                    backgroundColor: '#FFF',
                                    paddingLeft: 4,
                                    paddingRight: 4,
                                    color: '#3E3E3E',
                                },
                            }}
                            onChange={(e) => est2(e)}
                        />
                    </Grid>
                    <Grid style={{ width: '22%' }}>
                        <CssTextField
                            value={state.b2}
                            name="buy"
                            type="text"
                            autoComplete="off"
                            inputProps={{
                                "aria-label": "BUY",
                                style: {
                                    height: "1px",
                                    fontSize: "calc(14px + var(--font-delta))",
                                    fontFamily: 'cardiuma-Bold !important',
                                    backgroundColor: '#FFF',
                                    paddingLeft: 4,
                                    paddingRight: 4,
                                    color: '#3E3E3E',
                                },
                            }}
                            onChange={(e) => eb2(e)}
                        />
                    </Grid>
                    <Grid style={{ width: '22%' }}>
                        <CssTextField
                            value={state.s2}
                            name="sell"
                            type="text"
                            autoComplete="off"
                            inputProps={{
                                "aria-label": "SELL",
                                style: {
                                    height: "1px",
                                    fontSize: "calc(14px + var(--font-delta))",
                                    fontFamily: 'cardiuma-Bold !important',
                                    backgroundColor: '#FFF',
                                    paddingLeft: 4,
                                    paddingRight: 4,
                                    color: '#3E3E3E',
                                },
                            }}
                            onChange={(e) => es2(e)}
                        />
                    </Grid>
                    <Grid style={{ width: '20%' }}>
                        <CssTextField
                            value={state.q2}
                            name="quantity"
                            type="text"
                            autoComplete="off"
                            inputProps={{
                                "aria-label": "QUANTITY",
                                style: {
                                    height: "1px",
                                    fontSize: "calc(14px + var(--font-delta))",
                                    fontFamily: 'cardiuma-Bold !important',
                                    backgroundColor: '#FFF',
                                    paddingLeft: 4,
                                    paddingRight: 4,
                                    color: '#3E3E3E',
                                },
                            }}
                            onChange={(e) => eq2(e)}
                        />
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex', marginTop: '10px', justifyContent: 'center' }}>
                    <RadioGroup
                        row
                        value={state.opt2}
                        onChange={handle2}
                    >
                        <FormControlLabel value="nse2" control={<Radio
                            disableRipple
                            size='small'
                            sx={{
                                color: "#093265",
                                "&.Mui-checked": {
                                    position: "relative",
                                    "&::before": {
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        color: "yellow"
                                    },
                                    "&::after": {
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        backgroundColor: "#093265",
                                        borderColor: "#ffffff",
                                        color: "yellow"
                                    },
                                    '& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root) path':
                                    {
                                        stroke: '#ffffff',
                                        strokeWidth: 0.5,
                                    },
                                }
                            }}
                        />} label={<Typography className={classes.bopttxt}>{t.nse}</Typography>} />
                        <FormControlLabel value="bse2" control={<Radio
                            size='small'
                            sx={{
                                color: "#093265",
                                "&.Mui-checked": {
                                    position: "relative",
                                    "&::before": {
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        color: "yellow"
                                    },
                                    "&::after": {
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        backgroundColor: "#093265",
                                        borderColor: "#ffffff",
                                        color: "yellow"
                                    },
                                    '& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root) path':
                                    {
                                        stroke: '#ffffff',
                                        strokeWidth: 0.5,
                                    },
                                }
                            }}
                        />} label={<Typography className={classes.bopttxt}>{t.bse}</Typography>} />
                    </RadioGroup>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex' }}>
                    <Grid style={{ width: '50%' }}>
                        <Typography className={classes.subtit1}>{t.turnover}</Typography>
                    </Grid>
                    <Grid style={{ width: '50%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.turnover2}</Typography>
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid style={{ width: '50%' }}>
                        <Typography className={classes.subtit1}>{t.brokerage}</Typography>
                    </Grid>
                    <Grid style={{ width: '50%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.brokerage_buy2}</Typography>
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.exchangeTxnCharge}</Typography>
                    </Grid>
                    <Grid style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.exc_trans_charge2}</Typography>
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.clearingCharge}</Typography>
                    </Grid>
                    <Grid style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.dp}</Typography>
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.gst}</Typography>
                    </Grid>
                    <Grid style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.gst2}</Typography>
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.sebiCharges}</Typography>
                    </Grid>
                    <Grid style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.sebi_charges2}</Typography>
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.stampDuty}</Typography>
                    </Grid>
                    <Grid style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.stamp_charges2}</Typography>
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.totalTaxCharges}</Typography>
                    </Grid>
                    <Grid style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.total_tax2}</Typography>
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid style={{ width: '60%' }}>
                        <Typography className={classes.subtit1}>{t.pointsBreakeven}</Typography>
                    </Grid>
                    <Grid style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.breakeven2}</Typography>
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex', marginTop: '15px' }}>
                    <Grid style={{ width: '50%' }}>
                        <Typography className={classes.subtit1}>{t.pipsBreakeven}</Typography>
                    </Grid>
                    <Grid style={{ width: '50%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={classes.bsubtit2}>{state.pips2}</Typography>
                    </Grid>
                </Grid>
                <Grid style={{ width: '100%', display: 'flex', marginTop: '30px' }}>
                    <Grid style={{ width: '60%' }}>
                        <Typography className={classes.nettit} sx={{fontWeight:700}}>{t.netPL}</Typography>
                    </Grid>
                    <Grid style={{ width: '40%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Typography className={state.net_profit2 > 0 ? classes.netamt : classes.netamt1}>{state.net_profit2}</Typography>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
};

export default withStyles(styles)(Currency);
